'use strict';
import {ClientEventType} from "../../../../services/client-events/models/ClientEventType";

{
    var app = angular.module('tf.portfolio.widgets.tradersCircle', [])
        .factory('tradersCirclePayoff', ['$http', '$timeout', 'moment', 'uiGridConstants', function($http, $timeout, moment, uiGridConstants) {


            function shortLongClass(grid, row, col, rowRenderIndex, colRenderIndex) {
                var value = grid.getCellValue(row,col);
                if (value < 0) {
                    return 'gridNumber short';
                } else {
                    return 'gridNumber';
                }
            }

            var service = {};

            service.timeSeriesData = [];
            service.points = true;
            service.grid = {
                data : [],
                columnDefs : []
            };

            service.updateTimer = null;

            service.calculate = function(payoffParams) {
                var self = this;

                if (self.updateTimer) {
                    $timeout.cancel(self.updateTimer);
                    self.updateTimer = null;
                }

                this.updateTimer = $timeout(function() {
                    self.updateTimer = null;
                    $http.post('/tradefloor/api/payoff', payoffParams)
                        .then(function (response) {
                            var data = response.data;
                            self.points = data.points;

                            var gridData = [];
                            var expiry = data.dateSteps[data.dateSteps.length - 1];

                            var seriesData = data.dateSteps.map(function (d) {
                                //var a = moment.duration(expiry, 'd');
                                //var b = moment.duration(d, 'd');
                                var difference = Math.round(moment(expiry).diff(moment(d))/(60*60*24*1000));
                                return {
                                    key: moment(d).format('MMM Do YYYY') + ' (' + (difference) + 'd)' ,
                                    values: []
                                }
                            });
                            var filter;
                            if (payoffParams.theoOnly && data.points) {
                                filter = 'number : 1'
                            } else if (payoffParams.theoOnly) {
                                filter = 'number : 3'
                            } else {
                                filter = 'number : 0'
                            }
                            var columnDefs = [{
                                name: 'points',
                                field : 'price',
                                visible : data.points,
                                displayName: 'XJO',
                                enableColumnMenu: false,
                                width: 90,
                                sort: {
                                    direction: uiGridConstants.DESC
                                },
                                cellFilter: 'points',
                                headerCellClass: 'gridNumber',
                                cellClass: 'gridNumber',
                                pinnedLeft: true
                            },
                                {
                                    name: 'price',
                                    field : 'price',
                                    sort: {
                                        direction: uiGridConstants.DESC
                                    },
                                    visible : !data.points,
                                    displayName: 'Price',
                                    enableColumnMenu: false,
                                    width: 90,
                                    cellFilter: 'strike : false',
                                    headerCellClass: 'gridNumber',
                                    cellClass: 'gridNumber',
                                    pinnedLeft: true
                                }]
                                .concat(data.dateSteps.map(function (d, i) {
                                    return {
                                        name: 't' + i + (payoffParams.theoOnly ? 'theo' : 'value'),
                                        field : 't' + i,
                                        enableColumnMenu: false,
                                        minWidth: 90,
                                        displayName: d,
                                        headerCellClass: 'gridNumber',
                                        cellClass: shortLongClass,
                                        cellFilter: filter
                                    }
                                }));

                            var midpoint = (data.priceSteps.length - 1) / 2;
                            var steps = (data.priceSteps.length - 1) / 2;

                            for (var i = 0; i < data.priceSteps.length; i++) {

                                var row = {
                                    price: data.priceSteps[i],
                                    midpoint : i == midpoint
                                };


                                for (var j = 0; j < data.dateSteps.length; j++) {


                                    var dataPosition = j * data.priceSteps.length + i;

                                    if (payoffParams.theoOnly) {
                                        row['t' + j] = data.theoChangeData[dataPosition];
                                    } else {
                                        row['t' + j] = data.payOffData[dataPosition];
                                    }

                                    seriesData[j].values.push({
                                        x: i - steps,
                                        y: data.payOffData[dataPosition]
                                    });
                                }

                                gridData.push(row);
                            }

                            service.timeSeriesData = seriesData;
                            service.grid = {
                                columnDefs : columnDefs,
                                data : gridData
                            };

                            service.priceSteps = data.priceSteps;
                        });
                }, 750);

            };


            return service;
        }])
        .controller('tradersCirclePayoffDetailCtrl',
            ['$scope', '$localStorage', '$http', '$document', '$timeout', 'gridUtil', 'tradersCirclePayoff', 'uiGridConstants', '$stateParams', "clientEventService",
                function tradersCirclePayoffDetailCtrl($scope, $localStorage, $http, $document, $timeout, gridUtil, tradersCirclePayoff, uiGridConstants, $stateParams, clientEventService) {

            $scope.tradersCirclePayoff = tradersCirclePayoff;
            $scope.widgetContentHeight = 500;

            $scope.isTheoOnly = false;

            const sub = clientEventService.events()
                                          .filter((evt) => evt.type === ClientEventType.BROKER_STATE_CHANGED)
                                          .subscribe(() => $scope.calculatePayoff());

            $scope.$on("$destroy", () => sub.unsubscribe());

            $scope.$on('gridster-resized', function() {
                $scope.updateHeight();
                $scope.$broadcast('rzSliderForceRender');
            });

            $scope.$watch('gridsterItem.sizeY', function() {
                $scope.updateHeight();
            });

            $scope.$on('gridster-item-resized-stop', function(widget) {
                $scope.updateHeight();
            });

            $scope.timeSeries = {
                options: {
                    floor: 1,
                    ceil: 30,
                    onEnd: function(id) {
                        $scope.calculatePayoff();
                        $scope.saveToStorage();
                    }
                }
            };

            $scope.updateHeight = function() {
                $scope.widgetContentHeight = $scope.calculateAvailableWidgetHeight($scope.gridsterItem);

                if (!$scope.gridApi) {
                    return;
                }

                var newFreeContentHeight = $scope.widgetContentHeight - 30 - 162;
                var oldRowCount = $scope.gridOptions.minRowsToShow;

                var newRowCount = Math.round((newFreeContentHeight - 30) / $scope.gridOptions.rowHeight);
                $scope.gridOptions.minRowsToShow = newRowCount;

                if (oldRowCount != newRowCount) {
                    var newHeight = ($scope.gridOptions.minRowsToShow * $scope.gridOptions.rowHeight) + 30;
                    $scope.gridApi.grid.gridHeight = newHeight;
                    // TODO this shouldn't be required as the grid should adjust its render container based on the rows to show or height
                    angular.element(document.getElementById('payoffDetailGrid')).css('height', newHeight + 'px');
                }
                $scope.gridApi.grid.handleWindowResize();
            };

            $scope.volUpModifiers = [{modifier : 0.5},
                {modifier : 0.2},
                {modifier :0.1},
                {modifier : 0.05}
            ];
            $scope.volDownModifiers = [
                {modifier : -0.5},
                {modifier : -0.2},
                {modifier : -0.1},
                {modifier : -0.05}
            ];

            // UI View model
            $scope.priceIncrement = {
                preset : {
                    presets: [
                        {increment: 1, type: 'PERCENT'},
                        {increment: 2, type: 'PERCENT'},
                        {increment: 3, type: 'PERCENT'},
                        {increment: 4, type: 'PERCENT'}
                    ],
                    selectedPreset: null
                },
                custom : {
                    increment : 0,
                    type : 'FIXED'
                }
            };

            $scope.selectCustomPriceType = function() {
                calculatePayoff();
            };


            $scope.selectCustomPrice = function() {
                $scope.activePriceIncrement = $scope.customPriceIncrement;

                calculatePayoff();

            };

            $scope.activeVolModifier = null;

            $scope.gridOptions = {
                minRowsToShow : 8,
                enableVerticalScrollbar : uiGridConstants.scrollbars.ALWAYS,
                enableHorizontalScrollbar : uiGridConstants.scrollbars.ALWAYS,
                rowTemplate : "<div ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.uid\" ui-grid-one-bind-id-grid=\"rowRenderIndex + '-' + col.uid + '-cell'\" class=\"ui-grid-cell\" ng-class=\"{ 'ui-grid-row-header-cell': col.isRowHeader, 'midpoint' : row.entity.midpoint }\" role=\"{{col.isRowHeader ? 'rowheader' : 'gridcell'}}\" ui-grid-cell></div>",
                onRegisterApi: function(gridApi){
                    $scope.gridApi = gridApi;
                    gridUtil.disableAnimations(gridApi.grid.element);
                }
            };

            $scope.$watch('tradersCirclePayoff.grid', function (grid) {
                if (grid) {
                    $scope.gridOptions.data = grid.data;
                    $scope.gridOptions.columnDefs = grid.columnDefs;
                    if ($scope.gridApi) {
                        $scope.gridApi.grid.refresh();
                    }
                }
            });

            var currentWhatIf = null;

            $scope.gridOptions.columnDefs = [];

            $scope.includeRealPositions = true;

            $scope.toggleIncludeRealPositions = function() {
                $scope.includeRealPositions = !$scope.includeRealPositions;
                $scope.calculatePayoff();
                $scope.saveToStorage();
            };

            $scope.$on('whatif.changed', function updateData(event, whatIf) {
                $scope.whatIfPositions = [];

                if (whatIf) {
                    if (currentWhatIf && whatIf.id != currentWhatIf.id) {
                        $scope.priceAdjustments = null;
                    }
                    whatIf.trades.forEach(function(t) {
                        $scope.whatIfPositions.push(t)
                    });
                }


                currentWhatIf = whatIf;
                if (!whatIf) {
                    $scope.includeRealPositions = true;
                }
                $scope.widgetStorageKey = whatIf ? 'widgetParams_whatIf_' + whatIf.id : 'widgetParams_portfolio_' + $stateParams.portfolioId;

                $scope.loadFromStorage();
                $scope.calculatePayoff();
            });

            $scope.selectVolModifier = function(volModifier) {
                if ($scope.activeVolModifier == volModifier) {
                    $scope.activeVolModifier = null;
                } else {
                    $scope.activeVolModifier = volModifier;
                }

                $scope.calculatePayoff();
                $scope.saveToStorage();
            };

            $scope.selectPriceIncrement = function(priceIncrement) {
                if ($scope.priceIncrement.preset.selectedPreset === priceIncrement) {
                    return;
                }

                $scope.priceIncrement.preset.selectedPreset = priceIncrement;

                $scope.calculatePayoff();
                $scope.saveToStorage();
            };

            $scope.changeCustomPriceType = function(priceType) {
                if (priceType != $scope.priceIncrement.custom.type) {
                    $scope.priceIncrement.custom.increment = 0;
                }

                $scope.priceIncrement.preset.selectedPreset = null;

                $scope.priceIncrement.custom.type = priceType;
                $scope.calculatePayoff();
                $scope.saveToStorage();
            };

            $scope.changeCustomPrice = function() {
                $scope.priceIncrement.preset.selectedPreset = null;

                $scope.calculatePayoff();
                $scope.saveToStorage();
            };

            $scope.calculatePayoff = function() {
                // if (!currentWhatIf) {
                //     return;
                // }

                var tradesForPayoff = [];
                var equityTrades = [];
                $scope.whatIfPositions.forEach(function(t) {
                    if (t.code.length === 3) {
                        equityTrades.push(t);
                    } else {
                        tradesForPayoff.push(t)
                    }
                });
                if ($scope.includeRealPositions) {
                    if ($scope.portfolio) {
                        $scope.portfolio.positions.forEach(function (p) {
                            var trade = {
                                quantity: p.q,
                                code: p.c
                            };
                            tradesForPayoff.push(trade);
                        });
                    }
                }

                $scope.isMultiPosition = false;

                if (tradesForPayoff.length != 1) {
                    for (var i = 0; i < tradesForPayoff.length; i++) {
                        for (var j = 0; j < tradesForPayoff.length; j ++) {
                            if (tradesForPayoff[i].code.substring(0,3) != tradesForPayoff[j].code.substring(0,3)) {
                                $scope.isMultiPosition = true;
                                $scope.isTheoOnly = false;
                            }
                        }
                    }
                }

                var priceIncrement = $scope.isShowSimple ? $scope.priceIncrement.preset.selectedPreset : $scope.priceIncrement.custom;

                var payoffParams = {
                    volatilityAdjustments : [{
                        code : "XJO",
                        volShift : $scope.activeVolModifier ? $scope.activeVolModifier.modifier : 0
                    }],
                    priceIncrement : priceIncrement.increment,
                    priceIncrementType : priceIncrement.type,
                    timeIncrement : $scope.timeIncrement.increment || 1,
                    timeSteps : 8,
                    priceSteps : 5,
                    trades : tradesForPayoff,
                    equityTrades : equityTrades,
                    priceAdjustments : $scope.priceAdjustments,
                    theoOnly : $scope.isTheoView
                };
                tradersCirclePayoff.calculate(payoffParams);
            };

            $scope.$on('stress.scenario.change', function updateData(event, scenario) {
                if (!scenario) {
                    $scope.priceAdjustments = null;
                } else {
                    var priceAdjustments = [];

                    if (scenario.marketScenario != null) {
                        var marketAdjustment = {
                            code : "Market",
                            priceOverride : scenario.marketScenario.price
                        };
                        priceAdjustments.push(marketAdjustment);
                    }
                    if (scenario.securityScenarios != null) {
                        for (var i = 0; i < scenario.securityScenarios.length; i++) {
                            var priceAdjustment = {
                                code : scenario.securityScenarios[i].security,
                                priceOverride : scenario.securityScenarios[i].price
                            };
                            priceAdjustments.push(priceAdjustment);
                        }
                    }
                    $scope.priceAdjustments = priceAdjustments;
                }

                $scope.calculatePayoff();
            });

            $scope.isTheoView = false;
            $scope.isPayoffView = true;

            $scope.viewTheo = function() {
                $scope.isTheoView = true;
                $scope.isPayoffView = false;
                $scope.calculatePayoff();
                $scope.saveToStorage();
            };

            $scope.viewPayoff = function() {
                $scope.isTheoView = false;
                $scope.isPayoffView = true;
                $scope.calculatePayoff();
                $scope.saveToStorage();
            };

            $scope.toggleSimpleView = function() {
                $scope.isShowSimple = !$scope.isShowSimple;
                $scope.saveToStorage();
            };

            $scope.saveToStorage = function() {
                $localStorage[$scope.widgetStorageKey] = {
                    version : 1,
                    timeIncrement : $scope.timeIncrement.increment,
                    volModifier : {
                        selectedPreset : $scope.activeVolModifier ? $scope.activeVolModifier.modifier : 0
                    },
                    isShowSimple : $scope.isShowSimple,
                    priceIncrement : {
                        preset : {
                            selectedPreset : $scope.priceIncrement.preset.selectedPreset ? $scope.priceIncrement.preset.selectedPreset : null
                        },
                        custom : {
                            type : $scope.priceIncrement.custom.type,
                            increment : $scope.priceIncrement.custom.increment
                        }
                    }
                };
            };


            $scope.loadFromStorage = function() {
                if ($localStorage[$scope.widgetStorageKey]) {
                    $scope.activeVolModifier = null;
                    $scope.volUpModifiers.forEach(function(v) {
                        if (v.modifier == $localStorage[$scope.widgetStorageKey].volModifier.selectedPreset) {
                            $scope.activeVolModifier = v;
                        }
                    });
                    $scope.volDownModifiers.forEach(function(v) {
                        if (v.modifier == $localStorage[$scope.widgetStorageKey].volModifier.selectedPreset) {
                            $scope.activeVolModifier = v;
                        }
                    });
                    var custom = $localStorage[$scope.widgetStorageKey].priceIncrement.custom;
                    $scope.priceIncrement.custom.increment = custom.increment;
                    $scope.priceIncrement.custom.type = custom.type;
                    if ($localStorage[$scope.widgetStorageKey].priceIncrement.preset.selectedPreset) {
                        $scope.priceIncrement.preset.presets.forEach(function(p) {
                            if (p.increment == $localStorage[$scope.widgetStorageKey].priceIncrement.preset.selectedPreset.increment) {
                                $scope.priceIncrement.preset.selectedPreset = p;
                            }
                        });
                    }
                    if ($scope.priceIncrement.custom.increment == null) {
                        $scope.isShowSimple = true;
                    } else {
                        $scope.isShowSimple = $localStorage[$scope.widgetStorageKey].isShowSimple;
                    }
                    $scope.timeIncrement = {
                        increment : $localStorage[$scope.widgetStorageKey].timeIncrement
                    };

                } else {
                    $localStorage[$scope.widgetStorageKey] = {
                        version: 1,
                        isShowSimple : true,
                        timeIncrement : 15,
                        volModifier: {
                            selectedPreset: 0
                        },
                        priceIncrement: {
                            preset: {
                                selectedPreset : {
                                    increment : 1
                                }
                            },
                            custom: {
                                type: 'FIXED',
                                increment: null
                            }
                        }
                    };
                    $scope.loadFromStorage();
                }
            };

            $scope.realPositions = [];
            $scope.includeRealPositions = true;
            $scope.whatIfPositions = [];

            $scope.widgetStorageKey = 'widgetParams_portfolio_' + $stateParams.portfolioId;
            $scope.loadFromStorage();

            $scope.calculatePayoff();

            // Force update so slider can resize
            $timeout(function () {
                $scope.$broadcast('rzSliderForceRender');
            });

        }])
        .controller('tradersCirclePayoffChartCtrl', ['$scope', '$localStorage', '$http', '$document', '$timeout', 'tradersCirclePayoff', function tradersCirclePayoffChartCtrl($scope, $localStorage, $http, $document, $timeout, tradersCirclePayoff) {
            $scope.tradersCirclePayoff = tradersCirclePayoff;

            $scope.widgetContentHeight = 500;

            $scope.$on('gridster-resized', function() {
                $scope.updateChartHeight();
            });

            $scope.$on('gridster-item-resized-stop', function(widget) {
                $scope.updateChartHeight();
            });

            $scope.updateChartHeight = function() {
                $scope.widgetContentHeight = $scope.calculateAvailableWidgetHeight($scope.gridsterItem);
                $scope.payoffDataOptions.chart.height = $scope.widgetContentHeight - 30;
                if ($scope.chartApi) {
                    $scope.chartApi.refresh();
                }
            };

            $scope.payoffDataOptions = {
                chart: {
                    type: 'lineChart',
                    height: 450,
                    margin : {
                        top: 20,
                        right: 20,
                        bottom: 40,
                        left: 55
                    },
                    x: function(d){ return d.x; },
                    y: function(d){ return d.y; },
                    useInteractiveGuideline: true,
                    interactiveLayer : {
                        tooltip : {
                            // This is broken but looks better than the other options
                            gravity : 'center',
                            headerFormatter : function (d) {
                                var steps = (tradersCirclePayoff.priceSteps.length - 1) / 2;

                                var index = d + steps;
                                var price = tradersCirclePayoff.priceSteps[index];

                                return "Price " + (tradersCirclePayoff.points ? d3.format('.01f')(price) : d3.format(',.03f')(price));
                            }
                        }
                    },
                    dispatch: {

                    },
                    xAxis: {
                        axisLabel: 'Price Change',
                        tickFormat: function(d){
                            var steps = (tradersCirclePayoff.priceSteps.length - 1) / 2;

                            var index = d + steps;
                            var price = tradersCirclePayoff.priceSteps[index];

                            return tradersCirclePayoff.points ? d3.format('.01f')(price) : d3.format(',.03f')(price);
                        }

                    },
                    yAxis: {
                        axisLabel: 'Payoff ($)',
                        tickFormat: function(d){
                            return d3.format(',f')(d);
                        },
                        axisLabelDistance: -10
                    }
                }
            };

            $scope.payoffData = [];

            $scope.$watch('tradersCirclePayoff.timeSeriesData', function (data) {
                $scope.payoffData = data;
            });

        }]);
}
